import api from './api';

export const reportsService = {
  // Get all reports with pagination
  getReports: async (params = {}) => {
    const response = await api.get('/reports/', { params });
    return response.data;
  },

  // Generate a new report
  generateReport: async (reportData) => {
    const response = await api.post('/reports/', reportData);
    return response.data;
  },

  // Legacy support
  createReport: async (reportData) => {
    const response = await api.post('/reports/', reportData);
    return response.data;
  },

  // Get report by ID
  getReportById: async (id) => {
    const response = await api.get(`/reports/${id}/`);
    return response.data;
  },

  // Update report
  updateReport: async (id, reportData) => {
    const response = await api.put(`/reports/${id}/`, reportData);
    return response.data;
  },

  // Delete report
  deleteReport: async (id) => {
    await api.delete(`/reports/${id}/`);
  },

  // Get dashboard data
  getDashboardData: async () => {
    const response = await api.get('/reports/dashboard/');
    return response.data;
  },

  // Get team performance
  getTeamPerformance: async (params = {}) => {
    const response = await api.get('/reports/team-performance/', { params });
    return response.data;
  },

  // Legacy support
  getReportsData: async (filters = {}) => {
    const response = await api.get('/reports/', { params: filters });
    return response.data;
  },

  getAnalyticsData: async (params = {}) => {
    const response = await api.get('/reports/dashboard/', { params });
    return response.data;
  },

  // Download report file
  downloadReport: async (reportId) => {
    const response = await api.get(`/reports/${reportId}/download/`, {
      responseType: 'blob',
    });
    return response;
  },
};

// Report types
export const REPORT_TYPES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  CUSTOM: 'custom',
  PERFORMANCE: 'performance',
  ANALYTICS: 'analytics',
};

export const REPORT_TYPE_LABELS = {
  [REPORT_TYPES.DAILY]: 'Daily',
  [REPORT_TYPES.WEEKLY]: 'Weekly',
  [REPORT_TYPES.MONTHLY]: 'Monthly',
  [REPORT_TYPES.CUSTOM]: 'Custom',
  [REPORT_TYPES.PERFORMANCE]: 'Performance',
  [REPORT_TYPES.ANALYTICS]: 'Analytics',
};

// Report status
export const REPORT_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const REPORT_STATUS_LABELS = {
  [REPORT_STATUS.PENDING]: 'Pending',
  [REPORT_STATUS.PROCESSING]: 'Processing',
  [REPORT_STATUS.COMPLETED]: 'Completed',
  [REPORT_STATUS.FAILED]: 'Failed',
};